import { checkWindow } from '@vfit/shared/data-access';

const getReverseAddressParams = (): Record<string, string> => {
  if (!checkWindow()) return {};
  const params: Record<string, string> = {};
  const urlObj = new URL(window.location.href);

  urlObj.searchParams.forEach((value, key) => {
    params[key] = value;
  });

  return params;
};

export { getReverseAddressParams };
